import { FormView } from "../../UI/view/form-view";
import { vendorCreate } from "./vendor-form-create";

export const vendorUpdate: FormView = {
  ...vendorCreate
}